module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "customize-list"
  }, [_c('v-slide-y-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('v-list', [_vm._l((_vm.items), function(name, index) {
    return _c('v-list-tile', {
      key: index,
      attrs: {
        "avatar": ""
      },
      on: {
        "click": function($event) {
          _vm.goCustomDetail(name)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      staticClass: "white--text",
      class: _vm.themeColor
    }, [_vm._v("assignment")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(name))])], 1)
  }), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-content', [_c('v-btn', {
    attrs: {
      "block": "",
      "color": _vm.themeColor,
      "dark": ""
    },
    on: {
      "click": _vm.createNew
    }
  }, [_c('v-icon', {
    staticClass: "white--text",
    class: _vm.themeColor
  }, [_vm._v("add")]), _vm._v("\n            " + _vm._s(_vm.$t('New')) + "\n          ")], 1)], 1)], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99df50f2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/CustomizeList.vue
// module id = 435
// module chunks = 1